import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Dropdown } from 'primereact/dropdown'
import { Column } from 'primereact/column'
import { routes } from '../../../constants'
import { Page } from '../../../components/page/Page'
import { PerfilList } from './PerfilList'
import { actions } from '../perfil.actions'
import { getMessage } from '../../../utils/index'
import { InputText } from 'primereact/inputtext'
import { LoadingSpinner } from '../../../components/loadingSpinner/LoadingSpinner'
import {
  onColumnReorder,
  onColumnToggle,
  loadFavorito,
  changeFavorito,
  componentDidMount,
  componentDidUpdate,
  onPage,
  onSort,
  onCsvExport,
} from '../../../utils/listPageContainerUtils'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'

const mapStateToProps = (state) => {
  return {
    showHideColumns: state.crudPerfilState.showHideColumns,
    messages: state.crudPerfilState.messages,
    columns: state.crudPerfilState.columns,
    records: state.crudPerfilState.records,
    isLoadingRecords: state.crudPerfilState.isLoadingRecords,
    first: state.crudPerfilState.index,
    rows: state.crudPerfilState.max,
    totalRecords: state.crudPerfilState.count,
    sortField: state.crudPerfilState.sortField,
    order: state.crudPerfilState.sortOrder,
    booleanFilter: state.crudPerfilState.booleanFilter,
    booleanTypes: [
      { label: 'TODOS', value: '' },
      { label: 'SIM', value: true },
      { label: 'NÃO', value: false },
    ],
    selectedFilters: state.crudPerfilState.selectedFilters,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.applyFilter(filterParams))
    },
    changeFilter: (column, e) => {
      const target = e.target
      let campo = column.fieldJoin ? column.fieldJoin : target.name

      // tratamentos para nomes dos filtros boolean
      if (
        'administrador' === target.name ||
        'indicadorPersonalizado' === target.name ||
        'criaUsuariosWebService' === target.name ||
        'alteraUnidade' === target.name
      ) {
        dispatch(actions.setBooleanFilter(target.name, target.value))
      }

      dispatch(actions.setSelectedFilters(campo, target.value, column.relacionamento, column.field))
      setTimeout(() => {
        dispatch(actions.executeFilter(`/lottustech/perfis/all`))
      }, 400)
    },
    load: () => dispatch(actions.load()),
    setColumns: (columns) => dispatch(actions.loadColumns(columns)),
    loadFavorito: (menu) => {
      dispatch(actions.loadFavorito(menu))
    },
    removeFavorito: (menu) => {
      dispatch(actions.removeFavorito(menu))
    },
    adicionarFavorito: (menu) => {
      dispatch(actions.adicionarFavorito(menu))
    },
    clearSelectedFilters: () => {
      dispatch(actions.clearSelectedFilters())
    },
    exportarDadosCSV: () => {
      dispatch(actions.exportCSV())
    },
    getTemplateImportacao: () => {
      dispatch(actions.getTemplateImportacao())
    },
    uploadCsvImportacao: (arquivo) => {
      dispatch(actions.uploadCsvImportacao(arquivo))
    },
  }
}

class PerfilListPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.dataTableRef = React.createRef()
    this.columnSelect = React.createRef()
    this.showHideColumns = []
    this.state = {
      dadosFavorito: null,
      favorito: 0,
    }
    this.onColumnToggle = this.onColumnToggle.bind(this)
  }

  //parametro com todas as colunas selecionadas atualmente
  onColumnToggle(event) {
    onColumnToggle(event, this)
  }

  // MÉTODO CHAMADO AO REORDENAR AS COLUNAS
  onColReorder(e, colunasAtuais) {
    onColumnReorder(e, colunasAtuais, this)
  }

  exportar(excel = true) {
    onCsvExport(this.props.records, this, actions, excel)
  }

  loadFavorito() {
    loadFavorito(this, actions)
  }

  changeFavorito() {
    changeFavorito(this, actions)
  }

  newHandler = () => {
    this.props.history.push(`${routes.PATH_PERFIL}/novo`)
  }
  componentDidMount() {
    componentDidMount(this)
  }

  componentDidUpdate(prevProps, prevState) {
    componentDidUpdate(this, prevProps, prevState)
  }

  onPage = (e) => {
    onPage(this, e)
  }

  onSort = (e) => {
    onSort(this, e)
  }

  buildHeader = () => {
    return <DefaultToolBar listPageContainer={this} title={getMessage(this.props.messages, 'perfil.label.perfis')} />
  }

  oidTemplate = (rowData) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Link to={`${routes.PATH_PERFIL}/${rowData.oid}`}>{rowData.oid}</Link>
      </div>
    )
  }

  booleanFilter = (column) => {
    return (
      <Dropdown
        style={{ width: '100%' }}
        name={column.field}
        value={this.props.booleanFilter[column.field]}
        options={this.props.booleanTypes}
        onChange={(e) => this.props.changeFilter(column, e)}
      />
    )
  }

  fieldFilter = (column) => {
    return (
      <InputText
        style={{ width: '100%' }}
        name={column.field}
        value={this.props.selectedFilters[column.field]}
        onChange={(e) => this.props.changeFilter(column, e)}
      />
    )
  }

  booleanFieldsTemplate = (rowData, column) => {
    const result = rowData[column.field]
    if (result) {
      return (
        <div style={{ color: 'green', display: 'flex', justifyContent: 'center' }}>
          <span className="pi pi-check-circle" style={{ fontSize: '1.8rem' }} />{' '}
        </div>
      )
    } else {
      return (
        <div style={{ color: 'red', display: 'flex', justifyContent: 'center' }}>
          <span className="pi pi-times-circle" style={{ fontSize: '1.8rem' }} />
        </div>
      )
    }
  }

  defineColumns = () => {
    const visibleColumns = this.props.columns.filter((col) => col.visible)
    return visibleColumns.map((col) => {
      col.showFilterMenuOptions = false
      if (col.field === 'oid') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.oidTemplate}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
          />
        )
      } else if (
        ['indicadorPersonalizado', 'administrador', 'criaUsuariosWebService', 'alteraUnidade'].find(
          (field) => field === col.field
        )
      ) {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.booleanFieldsTemplate}
            sortField={col.columnSortField}
            filterElement={this.booleanFilter(col)}
          />
        )
      }
      return <Column {...col} key={col.field} sortField={col.columnSortField} filterElement={this.fieldFilter(col)} />
    })
  }
  buildContent = () => {
    return (
      <PerfilList
        {...this.props}
        dataTableRef={(el) => (this.dataTableRef = el)}
        onColReorder={(e) => this.onColReorder(e, this.showHideColumns)}
        onPage={this.onPage}
        onSort={this.onSort}
        columns={this.defineColumns()}
      />
    )
  }
  render() {
    if (this.props.columns && this.props.columns.length > 0) {
      // O LoadingSpinner abaixo so cobre a primeira montagem, quando ainda nao ha colunas.
      // Depois disso paginar/ordenar/filtrar refaz a consulta com a grade ja na tela: o
      // `loading` do Page vela so a grade, sem prender o menu nem a toolbar.
      return <Page header={this.buildHeader()} content={this.buildContent()} loading={this.props.isLoadingRecords} />
    }
    return <LoadingSpinner />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PerfilListPageContainer)
